/**
 * @module support/infinea
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * Enum values for scanner state, to be used to identify in case
 * barcode is flagged as unknown by infinea library
 */

export enum ScannerScanTargetTypeEnum {
  SKU,
  IMEI,
  UPC,
  DL,
  SIM,
}
